// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"87":"72728853","143":"1a02a1eb","417":"2f22e399","912":"72728853"}[chunkId] + ".chunk.css");